"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _1 = require("./");
const PopoverSearch = ({ device, isSearchFocused, removeFocus, setFocus, submitText, text, style, }) => {
    const getTextStyle = () => {
        if (isSearchFocused) {
            return {
                width: device === 'Mobile' ? 280 : 320,
                height: 24,
                lineHeight: '24px',
                display: 'flex',
                alignItems: 'center',
            };
        }
        return {
            width: device === 'Mobile' ? 280 : 320,
            height: 24,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    };
    return (React.createElement("div", { style: Object.assign({ backgroundColor: _1.cloud, width: '100%', paddingBottom: 14, paddingLeft: device === 'Mobile' ? 24 : 16, paddingRight: device === 'Mobile' ? 24 : 16, flex: '0 0 auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', boxSizing: 'border-box' }, style), onClick: (e) => e.stopPropagation() },
        React.createElement("div", { style: {
                width: '100%',
                height: 28,
                backgroundColor: 'white',
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
            }, onClick: (e) => setFocus() },
            React.createElement("div", { style: {
                    height: 16,
                    width: 16,
                    margin: '0 8px',
                } },
                React.createElement(_1.SearchIcon, { fill: _1.silver, height: "16", width: "16", viewBox: "0 0 24 24" })),
            React.createElement(_1.Text, { contentEditable: isSearchFocused, handleChange: removeFocus, id: "popover-search", onBlurChange: true, onInputChange: (searchString) => submitText(searchString), placeholder: true, placeholderText: "Search", size: "medium", text: text, textStyle: getTextStyle() }))));
};
exports.default = PopoverSearch;
